import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export default function CantFindItCTA() {
  return (
    <section data-testid="cant-find-cta" className="section-y bg-navy border-t border-white/5">
      <div className="container-editorial">
        <div className="grid grid-cols-12 gap-8 md:gap-16 items-end">
          <div className="col-span-12 md:col-span-7">
            <motion.span
              initial={{ scaleX: 0 }} whileInView={{ scaleX: 1 }}
              viewport={{ once: true, amount: 0.6 }}
              transition={{ duration: 1.2, ease: [0.19, 1, 0.22, 1] }}
              className="block h-px bg-[#C5A059] w-14 mb-8 origin-left"
            />
            <div className="overline text-[#C5A059] mb-6">Can't Find It?</div>
            <h2 className="font-display text-5xl md:text-6xl leading-[0.95] tracking-tight">
              If it isn't on the site,<br/>
              <em className="italic text-[#C5A059]">we'll find it for you.</em>
            </h2>
            <p className="editorial-body mt-10 max-w-xl">
              Every week we source vehicles that never touch our public inventory.
              Tell us the make, model and year — or simply describe what you're after —
              and a member of the Maklan Motors team will personally take it from there.
            </p>
          </div>
          <div className="col-span-12 md:col-span-4 md:col-start-9 flex flex-col gap-3 md:items-end">
            <Link to="/import" data-testid="cant-find-import-cta" className="btn-editorial btn-editorial-gold">
              Import on Request <ArrowRight size={14} />
            </Link>
            <Link to="/contact" data-testid="cant-find-contact-cta" className="btn-editorial">
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
